module.exports = "/packs/beauty-logo-white-72807b253646a3ddaa00a1e10065c0ba.png";